import React from "react";
import {
  MDBAlert, MDBTableBody, MDBTable, MDBInput, MDBCardTitle, MDBCard, MDBBtn, MDBRow, MDBCol, MDBView, MDBMask, MDBDataTableV5
} from 'mdbreact';
import MasterPage from './master_page';
import { connect } from 'react-redux';
import { addToCard, buscarMarca, validateMatricula, searchMatricula, crearFichero, eliminarRegistros, buscarTodosLosUsuariosRegistrados, verificarActivoFiltroCurso,getCursosActivos } from '../actionCreators';
import history from '../history';
import store from '../store'
import { newFormatDate } from './librerias/herramientas'


const Home = ({ allDataUser, cursoActivo,activeButtonDescargar,activebuttonEliminar,activofiltroCurso }) => {
 
  return (
    <div>
      <MasterPage />
      <div className="fullscreenDiv">
        
            <div  className="center">
              <h2 className="textoHome">REGISTRO REEVOLUCIÓN</h2>
            </div>
       
         
      </div>
    </div>
  );
}


const mapStateToProps = state => {
  return {
    allDataUser: state.allDataUser,
    cursoActivo: state.cursoActivo,
    activeButtonDescargar: state.activeButtonDescargar,
    activebuttonEliminar:state.activebuttonEliminar,
    activofiltroCurso:state.activofiltroCurso
  };
}

export default connect(mapStateToProps)(Home);

